import { Typography } from '@mui/material';
import ActionButton from '@source/components/ActionButton';
import router from 'next/router';
import { useEffect, useState } from 'react';
import * as S from './styles';

type VideoSize = {
  width: number;
  height: number;
};

const VideoContainer: React.FC = (): JSX.Element => {
  const [videoSize, setVideoSize] = useState<VideoSize | undefined>();
  const [videoBoxWidth, setVideoBoxWidth] = useState<number>(300);

  useEffect(() => {
    if (window !== undefined) {
      const innerWidth = window.innerWidth;

      const mediumBreakPoint = 768;

      if (innerWidth < mediumBreakPoint) {
        const imageHeight = innerWidth / 1.2;

        setVideoSize({ height: imageHeight, width: innerWidth });
        return;
      }

      const imageWidth = innerWidth / 2;

      const imageHeight = imageWidth / 1.2;

      setVideoSize({ height: imageHeight, width: imageWidth });
    }
  }, []);

  const redirectToWizard = () => router.push('/create-challenge');

  return (
    <S.Container>
      {videoSize?.width && (
        <S.VideoBox
          width={videoSize?.width}
          height={videoBoxWidth * 0.7}
          ref={ref => ref && setVideoBoxWidth(ref.clientWidth)}
          src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/web/videos/riderize-home-video.mp4`}
          autoPlay
          controls
          muted
          loop
          preload="none"
        />
      )}

      <S.InnerBox>
        <Typography
          sx={{
            fontSize: {
              xs: '2rem',
              sm: '3rem',
              md: '4.8rem'
            },
            fontWeight: 600
          }}
        >
          {'A troca de categoria te incomoda?'}
        </Typography>

        <S.Text>
          {
            'No Riderize você pode liberar a troca de categoria, dando autonomia ao atleta.'
          }
        </S.Text>

        <S.ButtonsBox>
          <ActionButton
            label="Comece agora"
            labelcolor="blue"
            style={{ width: '100%' }}
            onClick={redirectToWizard}
          />
        </S.ButtonsBox>
      </S.InnerBox>
    </S.Container>
  );
};

export default VideoContainer;
